import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { EditGenericEndpointsComponent } from '../features/lt-endpoint/components/edit-generic-endpoints/edit-generic-endpoints.component';

@Injectable()
export class EditGenericEndpointsGuard  {

    canDeactivate(component: EditGenericEndpointsComponent): boolean | Observable<boolean> | Promise<boolean> {
          return component.canDeactivate() ? true :
            window.confirm('You are about to leave the page without saving your changes. Are you sure you want to leave this page?');
    }

}
